/* TT-CUSTOM 2026-10-31: TOYTAG pickup card toggle. The card arrives through pickup-availability.js (innerHTML), so the
   behaviour lives in a custom element that wires itself up whenever a card is inserted. The open state is kept on the
   parent <pickup-availability>, so a variant change re-renders the card in the same state. */
if (!customElements.get('tt-pickup-card')) {
  customElements.define(
    'tt-pickup-card',
    class TtPickupCard extends HTMLElement {
      connectedCallback() {
        if (this.ttpkReady) return;
        this.toggleButton = this.querySelector('[data-ttpk-toggle]');
        this.panel = this.querySelector('[data-ttpk-panel]');
        if (!this.toggleButton || !this.panel) return;
        this.ttpkReady = true;
        this.host = this.closest('pickup-availability');
        this.setOpen(!!this.host && this.host.dataset.ttpkOpen === 'true');
        this.toggleButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.setOpen(!this.hasAttribute('data-open'));
        });
      }

      setOpen(open) {
        this.toggleAttribute('data-open', open);
        this.toggleButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (this.host) this.host.dataset.ttpkOpen = open ? 'true' : 'false';
      }
    }
  );
}
